import React, { useContext } from "react";

// Utils
import { CommonContext } from "config/commonProvider";

// Containers
import { BlockchainHeader, BlockchainSearch } from "containers/blockchain";

// Components
import { Page, PageContent, Root, SnackBarNotification, Spacer } from "components";

const BlockChain: React.FC = () => {
  const { changeMainCommonState, mainCommonState } = useContext(CommonContext);
  const { isShow = false, variant = "", message = "" } = { ...mainCommonState.notification };

  return (
    <>
      <Root>
        <Page>
          <BlockchainHeader />

          <PageContent>
            <Spacer baselineHeight={6}></Spacer>

            <BlockchainSearch />
          </PageContent>
        </Page>
      </Root>

      <SnackBarNotification
        open={isShow}
        variant={variant}
        message={message}
        onClose={(): void =>
          changeMainCommonState({
            ...mainCommonState,
            notification: null,
          })
        }
      />
    </>
  );
};

export default BlockChain;
